import React, { Component } from 'react';
import { push } from 'connected-react-router';
import propTypes from 'prop-types';

export default class RequireRoleBase extends Component {
  static propTypes = {
    isLoggedIn: propTypes.bool.isRequired,
    currentUserRole: propTypes.number.isRequired,
    requiredRole: propTypes.number
  }

  ensureAuth(props) {
    const { isLoggedIn, dispatch } = props;
    
    if(!isLoggedIn) {
      // send to login
      dispatch(push('/login'));
    } else if (this.isUserAdmin(props) === false) {
      dispatch(push('/login'));
    } else if(!this.hasRequiredRole(props)) {
      // send to forbidden page
      dispatch(push('/forbidden'));
    }
    return true;
  }

  hasRequiredRole({ requiredRole, currentUserRole }) {
    return !requiredRole || requiredRole === currentUserRole;
  }

  isUserAdmin (...props) {    
    return props.onlyAdmin ? props.isAdmin : true;
  }

  componentWillReceiveProps(props) {
    this.ensureAuth(props);
  }

  componentDidMount() {
    this.ensureAuth(this.props);
  }

  render() {
    const { isLoggedIn, children } = this.props;
    if(!isLoggedIn || !this.hasRequiredRole(this.props) || !this.isUserAdmin(this.props)) {
      console.log('retured null');
      return null;
    }

    return <div>{children}</div>;
  }
}